<template>
  <el-dialog class="MeterEditor" :append-to-body="true" :visible.sync="dialogVisible" :close-on-click-modal="false" width="90vw" @close="closeWin">
    <template #title>
      <el-button size="mini" @click="dialogVisible=false">关闭</el-button>
    </template>
    <div v-if="dialogVisible">
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="仪表信息" name="MeterInfoEditor">
          <MeterInfoEditor v-if="card_index==='MeterInfoEditor'" />
        </el-tab-pane>
        <el-tab-pane :label="form_data.energy===1?'计算模式':'分摊模式'" name="MeterApportionCustomer">
          <MeterApportionCustomer v-if="card_index==='MeterApportionCustomer'" />
        </el-tab-pane>
      </el-tabs>
    </div>

  </el-dialog>

</template>

<script>
import MeterInfoEditor from "./MeterInfoEditor";
import MeterApportionCustomer from "./MeterApportionCustomer";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterEditor",
  inject:['mainObj','componentId','setComponentId'],
  provide(){
    return{
      formData:()=>this.form_data
    }
  },
  components: {MeterApportionCustomer, MeterInfoEditor},
  data(){
    return{
      card_index:"MeterInfoEditor",
      dialogVisible: false,
      form_data:{}
    }
  },
  methods:{
    show(item=null,onlyId=false){
      const that=this;
      if(onlyId){
        that.getData(item.id,data=>{
          that.card_index="MeterInfoEditor";
          that.form_data=data;
          that.mainObj.id=data.id;
          that.dialogVisible=true;
        })
      }else {
        that.card_index="MeterInfoEditor";
        that.form_data=(item||{});
        that.mainObj.id=(item||{}).id;
        that.dialogVisible=true;
      }
    },
    closeWin(){
      this.mainObj.id="";
      this.form_data={};
    },
    getData(id,callback){
      MeterHttp.get(`admin/Meter/get?user_type=${this.$route.query.type||0}`,{id:id},ret=>{
        if(ret.code){
          callback(ret.data);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.MeterEditor{
  >>>.el-dialog__header{
    padding: 10px 20px 5px;
  }
  >>>.el-dialog__body{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterEditor.vue